<template>
    <grid
        ref="deposits"
        :is-auto-height="true"
        :is-auto-width="true"
        :is-search="false"
        :get-row-id="getRowId"
        :row-data="value"
        :column-defs="columnDefs"
        :style="{ marginBottom: '1rem' }"
        :pinnedBottomRowData="totals"
        :getRowStyle="getRowStyle"
        grid-theme="ag-theme-alpine-compact"
        :enableCellTextSelection="false"
    ></grid>
</template>

<script>
    import API from '../../../../api';
    import Grid from '../../../generic/grid/grid.vue';
    import ActionsCellRendererRemoveItem from './actions-cell-renderer-delete-item.vue';
    import { invoiceMixin } from '../../mixins/invoice-mixin';
    import { formatResponseError } from '../../../../utils/api';
    import { RESERVATION_TECHRESERVATION_DELETE_DEPOSIT_ENDPOINT } from '../../../../endpoints';

    export default {
        name: 'DepositsTable',
        components: {
            Grid,
            actionsCellRendererRemoveItem: ActionsCellRendererRemoveItem,
        },
        mixins: [invoiceMixin],
        props: {
            value: Array,
            totals: Array,
            metaReservationId: Number,
        },
        data() {
            return {
                isEdit: false,
                columnDefs: [
                    {
                        headerName: '',
                        maxWidth: 50,
                        flex: 1,
                        sortable: false,
                        resizable: false,
                        cellStyle: { textAlign: 'center' },
                        cellRenderer: 'actionsCellRendererRemoveItem',
                        cellRendererParams: {
                            deleteItem: (id, reservationId) => {
                                this.deleteItem(id, reservationId);
                            },
                        },
                    },
                    {
                        headerName: 'Description',
                        sortable: false,
                        field: 'description',
                        flex: 5,
                        autoWidthExclude: true,
                        minWidth: 200,
                    },
                    {
                        headerName: 'Date',
                        sortable: false,
                        field: 'date',
                        flex: 1,
                    },
                    {
                        headerName: 'Total',
                        sortable: false,
                        field: 'total',
                        flex: 1,
                        cellClass: 'ag-right-aligned-cell',
                        headerClass: 'ag-right-aligned-header',
                    },
                ],
            };
        },
        methods: {
            getRowId(item) {
                return item.data.id?.toString();
            },
            getRowStyle(params) {
                if (params.node.rowPinned === 'bottom') {
                    return {
                        'font-weight': 'bold',
                        'background-color': '#F8F8F8',
                    };
                }
            },
            async deleteItem(id, reservationId) {
                this.busy = true;
                try {
                    await API.delete(RESERVATION_TECHRESERVATION_DELETE_DEPOSIT_ENDPOINT(reservationId), {
                        data: { id: id },
                    });
                    await this.refreshReservationInvoice(this.metaReservationId);
                } catch (e) {
                    this.errorToast({ text: `Could not remove deposit.` });
                } finally {
                    this.busy = false;
                }
            },
        },
    };
</script>
